import {takeLatest, takeEvery, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchPostMorceau(action) {
	try {
		const result = yield fromApi.morceauPost(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'POST_MORCEAU_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetMorceaux(action) {
	try {
		const result = yield fromApi.morceauxGet(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_MORCEAUX_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutMorceau(action) {
	try {
		const result = yield fromApi.morceauPut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_MORCEAU_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutMorceauxOrdre(action) {
	try {
		const result = yield fromApi.morceauxOrdrePut(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_MORCEAUX_ORDRE_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchDelMorceau(action) {
	try {
		const result = yield fromApi.morceauDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_MORCEAU_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* morceaux() {
	yield takeLatest('POST_MORCEAU_SAGAS', watchPostMorceau);
	yield takeLatest('GET_MORCEAUX_SAGAS', watchGetMorceaux);
	// takeEvery : plusieurs bascules actif/inactif ou suppressions peuvent s'enchaîner rapidement
	yield takeEvery('PUT_MORCEAU_SAGAS', watchPutMorceau);
	yield takeLatest('PUT_MORCEAUX_ORDRE_SAGAS', watchPutMorceauxOrdre);
	yield takeEvery('DEL_MORCEAU_SAGAS', watchDelMorceau);
}

export default function* rootSaga() {
	yield all([morceaux()]);
}
